module.exports = __webpack_public_path__ + "img/pic-story-tab1-1.5f069377.jpg";